import { render, staticRenderFns } from "./Channels.vue?vue&type=template&id=dc870876&scoped=true"
import script from "./Channels.vue?vue&type=script&lang=js"
export * from "./Channels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc870876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc870876')) {
      api.createRecord('dc870876', component.options)
    } else {
      api.reload('dc870876', component.options)
    }
    module.hot.accept("./Channels.vue?vue&type=template&id=dc870876&scoped=true", function () {
      api.rerender('dc870876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/channels/Channels.vue"
export default component.exports